export default __webpack_public_path__ + "static/media/Landing-gmm1.a4244e2d.png";